/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Decorators from '../../Decorators';
import NodeReferenceData from '../Node/NodeReferenceData';
import ObservableNodeComponent from '../Observable/ObservableNodeComponent';
import ActionComponentBase from './ActionComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * An extension of [[ActionComponentBase]] that handles an "On" event and an "Off" event. The "On" event
 * triggers the standard [[ActionComponentBase]] action and the "off" event triggers the newly added offAction.
 */
@cc._decorator.ccclass
export default abstract class EventActionComponent extends ActionComponentBase
{
    /** The string name of the "On" event. */
    public abstract OnEventName: string;
    /** The string name of the "Off" event. */
    public abstract OffEventName: string;

    /** Implement the desired scripted "Off" action here. */
    protected abstract offAction: () => void;

    /** The node to listen for events on. */
    public TargetNode: ObservableNodeComponent = null;

    /** Editor exposed reference for setting the TargetNode. */
    @property({ type: NodeReferenceData })
    protected nodeReference: NodeReferenceData = new NodeReferenceData();

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.TargetNode = this.node.getComponentInChildren(ObservableNodeComponent);
    }

    /** @hidden */
    protected configureListeners(): void
    {
        if (!this.nodeReference.Value) { this.nodeReference.Value = this.node; }

        this.nodeReference.Value.on(this.OnEventName, this._eventAction);
        this.nodeReference.Value.on(this.OffEventName, this._eventOffAction);
    }

    /** @hidden */
    protected destroyListeners(): void
    {
        if (!this.nodeReference.Value) { return; }
        this.nodeReference.Value.off(this.OnEventName, this._eventAction);
        this.nodeReference.Value.off(this.OffEventName, this._eventOffAction);
    }

    /** @hidden */
    @Decorators.BindThis()
    private _eventAction = (event: cc.Event.EventCustom, detail?: any) =>
    {
        event.bubbles = true;

        if (this.TargetNode) { this.TargetNode.Value = event.target; }
        this.action();
    }

    /** @hidden */
    @Decorators.BindThis()
    private _eventOffAction = (event: cc.Event.EventCustom, detail?: any) =>
    {
        event.bubbles = true;

        if (this.TargetNode) { this.TargetNode.Value = event.target; }
        this.offAction();
    }
}
